import {Context, createContext} from 'react';
import {FuPaUser} from './authTypes';
import {User} from 'firebase/auth';

type UserContextType = {
  user: User | null;
  fupaUser: FuPaUser | null;
  isLoading: boolean;
  error: Error | null;
} | null;

export const UserContext: Context<UserContextType> = createContext<UserContextType>(null);
